let authConfig: {
	getAccessToken?: () => Promise<string | null>;
	instanceId?: string;
	evoOrganisationId?: string;
	companyId?: string;
} = {};

export function configureAuth(config: {
	getAccessToken?: () => Promise<string | null>;
	instanceId?: string;
	evoOrganisationId?: string;
	companyId?: string;
}): void {
	authConfig = { ...authConfig, ...config };
}

export function getAuthConfig(): {
	getAccessToken?: () => Promise<string | null>;
	instanceId?: string;
	evoOrganisationId?: string;
	companyId?: string;
} {
	return authConfig;
}

export function updateCompanyId(companyId: string | undefined): void {
	authConfig = { ...authConfig, companyId };
}

export async function authFetch(
	input: RequestInfo | URL,
	init?: RequestInit,
): Promise<Response> {
	const headers = new Headers(init?.headers);

	// Extract URL for logging
	let requestUrl: string;
	if (input instanceof Request) {
		requestUrl = input.url;
	} else if (input instanceof URL) {
		requestUrl = input.toString();
	} else {
		requestUrl = String(input);
	}

	if (authConfig.getAccessToken) {
		try {
			const token = await authConfig.getAccessToken();
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			} else {
				console.log(
					"%c[authFetch] No token available for request:",
					"color: orange;",
					{ url: requestUrl },
				);
			}
		} catch (error) {
			console.error("Error getting access token:", error);
		}
	} else {
		console.log(
			"%c[authFetch] No getAccessToken function configured.",
			"color: red;",
		);
	}

	// Always set X-Instance-Id header, with fallback if not configured
	const instanceId = authConfig.instanceId || "default-instance";
	headers.set("X-Instance-Id", instanceId);

	// Set X-Organisation-Id header only when a real value exists (no fallback)
	if (authConfig.evoOrganisationId) {
		headers.set("X-Organisation-Id", authConfig.evoOrganisationId);
	}

	// Set X-Company-Id header for active company selection
	if (authConfig.companyId) {
		headers.set("X-Company-Id", authConfig.companyId);
	}

	return fetch(input, {
		...init,
		headers,
		credentials: 'include',
	});
}
